// extracted by mini-css-extract-plugin
module.exports = {"title":"style-module__title___2qoUT"};